import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import { i18n, setLocale } from './i18n'

Vue.use(ElementUI)
Vue.prototype.$t = (key) => i18n.t(key)
Vue.prototype.$setLocale = setLocale

new Vue({
  router,
  render: (h) => h(App)
}).$mount('#app')
